import { render, staticRenderFns } from "./DraggableColumns.vue?vue&type=template&id=3d4116c7&"
import script from "./DraggableColumns.vue?vue&type=script&lang=js&"
export * from "./DraggableColumns.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports